import { Card, Stack, Text } from '@mantine/core';

const CouponFormSection = ({ title, children }) => (
  <Card withBorder mb="md">
    <Text fw={700} size="lg" mb="md">
      {title}
    </Text>
    <Stack gap="md">{children}</Stack>
  </Card>
);

export default CouponFormSection;
